import React from 'react';

import { neptuneUrls } from '@neptune/shared/common-domain';
import { Layout, Link, SimpleTooltip, Text } from '@neptune/shared/venus-ui';

export const RegExpInstructionsTooltip: React.FC<{
  placement?: React.ComponentProps<typeof SimpleTooltip>['placement'];
  additionalContent?: React.ReactNode;
  shortcutSlot?: React.ReactNode;
}> = ({ children, placement, additionalContent, shortcutSlot }) => {
  return (
    <>
      <SimpleTooltip
        placement={placement}
        content={
          <Layout.Row spacedChildren="sm" alignItems="baseline">
            {additionalContent && <Layout.Column span="greedy">{additionalContent}</Layout.Column>}
            <Layout.Column span="greedy">
              <Text>
                Supports extended regex.{' '}
                <Link type="secondary" href={neptuneUrls.regexCompoundExpressions} external>
                  See documentation
                </Link>
              </Text>
            </Layout.Column>
            {shortcutSlot && <Layout.Column span="auto">{shortcutSlot}</Layout.Column>}
          </Layout.Row>
        }
      >
        {children}
      </SimpleTooltip>
    </>
  );
};
